export default __webpack_public_path__ + "static/media/billing_management_mobile.5d361fc8.PNG";